<template>
  <div>
    <object><embed src="/privacy_policy.pdf" class="pdf" /></object>
  </div>
</template>
<script>
export default {
  name: 'Privacy',
  created() {
    console.log('Privacy created')
  },
}
</script>

<style lang="sass" scoped>
embed
  width: 100vw
  height: 100vh
</style>
